import React from 'react';
import { Input } from '@etiquette-ui/inputs-dropdowns';
import { SwitchButton } from '@etiquette-ui/selectors';
import { Subtitle, P } from '@etiquette-ui/typography';
import FormSection from 'containers/Form/FormSection';
import GridContainer from 'containers/Form/GridContainer';
import useI18n from 'i18n/useI18n';
import { ACTIONS } from '../../Reducer';
import WYSIWYG from '../../../../../../../../components/WYSIWYG';
import CATEGORY_KEYS, { CATEGORY_CONFIG_KEYS } from '../../keys';

const Details = ({ formData, dispatch, handleItemInfo }) => {
    const { translate } = useI18n();

    return (
        <FormSection>
            <Subtitle>{translate('Details')}</Subtitle>
            <GridContainer style={{margin: '15px 0px', gap: '15px'}}>
                <Input
                    labelProps={{ label: translate('Category Name (English)') }}
                    iconProps={{ icon: 'title' }}
                    inputProps={{
                        ...{
                            value: formData[CATEGORY_KEYS.TRANSLATIONS].en.title,
                            onChange: (e) => dispatch(ACTIONS.TRANSLATIONS, { lang: 'en', text: 'title', value: e.target.value }),
                            required: true,
                        },
                    }}
                />
                <Input
                    labelProps={{ label: translate('Category Name (Spanish)') }}
                    iconProps={{ icon: 'title' }}
                    inputProps={{
                        value: formData[CATEGORY_KEYS.TRANSLATIONS].es.title,
                        onChange: (e) => dispatch(ACTIONS.TRANSLATIONS, { lang: 'es', text: 'title', value: e.target.value }),
                        required: true,
                    }}
                />
            </GridContainer>
            <GridContainer style={{gap: '15px', marginBottom: '15px'}}>
                <WYSIWYG
                    onChange={(value) => dispatch(ACTIONS.CONFIG_MESSAGE, { key: 'translations.en.title', value })}
                    value={formData[CATEGORY_KEYS.CONFIG][CATEGORY_CONFIG_KEYS.MESSAGE][CATEGORY_KEYS.TRANSLATIONS].en.title}
                    backgroundColor={formData[CATEGORY_KEYS.CONFIG][CATEGORY_CONFIG_KEYS.MESSAGE].color}
                    iconProps={{ icon: 'align-left' }}
                    labelProps={{ label: translate('Message (English)') }}
                />
                <WYSIWYG
                    onChange={(value) => dispatch(ACTIONS.CONFIG_MESSAGE, { key: 'translations.es.title', value })}
                    value={formData[CATEGORY_KEYS.CONFIG][CATEGORY_CONFIG_KEYS.MESSAGE][CATEGORY_KEYS.TRANSLATIONS].es.title}
                    backgroundColor={formData[CATEGORY_KEYS.CONFIG][CATEGORY_CONFIG_KEYS.MESSAGE].color}
                    iconProps={{ icon: 'align-left' }}
                    labelProps={{ label: translate('Message (Spanish)') }}
                />
                <Input
                    labelProps={{ label: translate('Background Color') }}
                    iconProps={{ icon: 'number' }}
                    inputProps={{
                        ...{
                            value: formData[CATEGORY_KEYS.CONFIG][CATEGORY_CONFIG_KEYS.MESSAGE].color,
                            onChange: (e) => dispatch(ACTIONS.CONFIG_MESSAGE, { key: 'color', value: e.target.value }),
                            required: true,
                        },
                    }}
                />
            </GridContainer>
            <div style={{ display: 'flex', marginLeft: '-10px', alignItems: 'center' }} onClick={() => handleItemInfo(CATEGORY_KEYS.ACTIVE, !formData[CATEGORY_KEYS.ACTIVE])}>
                <SwitchButton active={formData[CATEGORY_KEYS.ACTIVE]} />
                <P style={{marginLeft: '15px'}}>
                {translate(
                    formData[CATEGORY_KEYS.ACTIVE] ? 'Category active' : 'Category inactive'
                )}
                </P>
            </div>
        </FormSection>
    );
};

export default Details;
